import { StyleSheet, Text, View } from '@react-pdf/renderer';

interface NestedColumnProps {
  rows: Array<{ title: string; value: any }>;
}

const NestedColumn = ({ rows }: NestedColumnProps) => {
  const childRows = rows.map((row, idx) => (
    <View wrap={false} key={idx} style={[styles.row, idx < rows.length - 1 ? styles.borderBottom : null]}>
      <Text style={styles.titleCell}>{row.title.toLowerCase()}</Text>
      <Text style={styles.valueCell}>{row.value}</Text>
    </View>
  ));

  return <View style={styles.container}>{childRows}</View>;
};

const styles = StyleSheet.create({
  container: {
    fontSize: 9,
    backgroundColor: '#15151505',
    borderWidth: 1,
    borderColor: '#E8E8E8',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    minHeight: 20,
    alignItems: 'center',
  },
  titleCell: {
    flex: 1,
    textAlign: 'left',
    fontWeight: 350,
    textTransform: 'capitalize',
    padding: 5,
  },
  valueCell: {
    flex: 2,
    textAlign: 'left',
    padding: 5,
    paddingTop: 10,
    borderLeft: '1px solid #E8E8E8',
    lineHeight: '0.8rem',
  },
  borderBottom: {
    borderBottom: '1px solid #E8E8E8',
  },
});

export default NestedColumn;
